import { TOGGLE_GOING_TO_CLOSE_PARKING } from "./displayGoingToCloseParkingReducer"

export const toggleGoingToCloseParking = (value) => ({
    type: TOGGLE_GOING_TO_CLOSE_PARKING,
    payload: value
})